/* eslint-disable */
export default {
    Images: {
        icon: require("../assets/image/logo.jpeg"),
        logo: require("../assets/image/logo.jpeg"),
        userIcon: require("../assets/image/userIcon.png"),
        backgroung: require("../assets/image/background.png"),
        backgroung2: require("../assets/image/background2.png"),
        tzFlag: require("../assets/image/tanzania.png"),
        ukFlag: require("../assets/image/uk.png"),
    }
}